<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(1.4 0.9)">
      <path d="M16.333,9.615H14.128a1.1,1.1,0,0,0-1.1,1.1v2.756a1.1,1.1,0,0,0,1.1,1.1h1.1a1.1,1.1,0,0,0,1.1-1.1Zm0,0A6.614,6.614,0,0,0,9.664,3,6.615,6.615,0,0,0,3,9.615v3.859a1.1,1.1,0,0,0,1.1,1.1h1.1a1.1,1.1,0,0,0,1.1-1.1V10.718a1.1,1.1,0,0,0-1.1-1.1H3" transform="translate(-3 -3)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
      <path d="M18.917,17.25V18.9a2.205,2.205,0,0,1-2.205,2.205H12.75" transform="translate(-5.584 -6.776)" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconHeadset',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>